import { Component, OnInit } from '@angular/core';
import { AccountService } from '../services/account/account.service';
import { ForuscareService } from '../services/foruscare/foruscare.service';
import { Configurations } from '../models/configurations';
import { FieldCustomizationService } from '../services/field-customization/field-customization.service';
import { DeviceService } from '../services/device/device.service';
import { List } from '@amcharts/amcharts4/core';
import { Account } from '../models/account';
import { DatePipe } from '@angular/common'
import { MRNConfig } from '../models/mrnConfig';

@Component({
  selector: 'app-configurations',
  templateUrl: './configurations.component.html',
  styleUrls: ['./configurations.component.css']
})
export class ConfigurationsComponent implements OnInit {

  accounts: [];
  devices: any[]=[];
  deviceId = null;
  accountId = null;
  copyFromAccountId = 0;
  configurationList: Configurations[];
  findingsList: Configurations[];
  progressionSectionList: Configurations[];
  recommendationList:Configurations[];
  operatorRemarksList:Configurations[];
  diagnosisOptions:any[];
  diseaseCategoryOptions:any[];
  eyeSegmentOptions:any[];
  recommendationOptions:any[];
  operatorRemarkOptions:any[];
  findingsOptions:any[];
  validToSubmit: boolean;
  cfg:Configurations;
  selectedTab:any="DIAGNOSIS";
  selectedAccount:any={};
  screeningCenterList:any[]=[];
  selectedScreeningCenter:any={};
  mrnConfig:MRNConfig;
  previewMRN:any="";
  selectedDateFormat:any="ddMMyyyy";
  selectedNoOfDigits:any=1;
  accountConfigurationValues:any[]=[];
  accountConfigurationKeys:any[]=[];
  accountConfigurationMap:any[]=[];
  constructor(public accountService: AccountService, public deviceService: DeviceService,public foruscareService: ForuscareService, public fieldCustomizationService: FieldCustomizationService,public datePipe:DatePipe) { }

  ngOnInit() {
    this.mrnConfig = new MRNConfig();
    this.configurationList = [];
    this.findingsList = [];
    this.progressionSectionList = [];
    this.recommendationList = [];
    this.operatorRemarksList = [];
    this.diagnosisOptions = ["ARMD", "BR", "BRVO","CAT", "CH","CHRPE", "CJ","CN","CO", "CRVO", "DME", "DMEA", "DMEU","DME_YES","DME_NO","DME_UNGRADABLE","DME_UNSPECIFIED", "DMO","DMOA","DP","DR", "DRA", "DRU","DR_MILD","DR_MODERATE","DR_SEVERE","DR_PROLIFERATIVE","DR_NO","DR_UNGRADABLE","DR_UNSPECIFIED", "EM","GLC", "GS", "HR", "H02.881 MGD","H02.882 MGD","H02.88A MGD","H02.884 MGD","H02.885 MGD","H02.88B MGD","IR", "LAT", "MAC", "MDME","MDR", "MEL","MF", "MH", "MHO","MNFL","MNPDR","MODME","MONPDR", "MODR", "MR","MY", "NF", "NR", "O","ORC", "ODE","ON","PAP", "PC","PD", "PDR", "PERD", "PPC", "PR", "PT","RD","RDRE", "RN","RP","RPEC", "RT","RTB", "S1Z1", "S1Z2", "S1Z3", "S2Z1", "S2Z2", "S2Z3", "S3Z1", "S3Z2", "S3Z3", "S4Z1", "S4Z2", "S4Z3", "S5", "SD","SDR","SDME","SNPDR","TF", "UTI", "VH","SEVERE_NPDR_NO_ME", "SEVERE_NPDR_ME", "MODERATE_NPDR_NO_ME", "MODERATE_NPDR_ME", "MILD_NPDR_NO_ME", "MILD_NPDR_ME", "PDR_NO_ME", "PDR_ME","PZ1","PZ1S2","PARP","HYRP","Z2PI","Z2PS1","Z2PS2","Z2PS3","Z2AS1","Z2AS2","Z2AS3","Z3S1","Z3S2","Z3S3","Z3S4A","ZPSP","CS","ZPIV","Z2AIV","Z3IV","MILD_PROLIFERATIVE_DIABETIC_RETINOPATHY","MODERATE_PROLIFERATIVE_DIABETIC_RETINOPATHY","SEVERE_PROLIFERATIVE_DIABETIC_RETINOPATHY","CYSTOID_MACULAR_OEDEMA","PSEUDOPHAKIA","NORMAL","EARLY_CATARACT","BLEPHARITIS","PINGECULA","SQUINT","STYE","CORNEAL_SCAR","CHALAZION","MICRO_CORNEA","MACRO_CORNEA","CORNEAL_ABNORMALITY","COLOBOMA_OF_IRIS","PIGMENTED_IRIS","IRIS_ATROPHY","SHALLOW_ANTERIOR_CHAMBER_","YAG_PI","PTOSIS","MEIBOMITIS","PSEUDOEXFOLIATION","LROP","AVROP"];
    this.diagnosisOptions.sort();
    this.diseaseCategoryOptions = [{"id":"NORMAL_FUNDUS","name":"Normal Fundus"},{"id":"DIABETIC_RETINOPATHY","name":"Diabetic Retinopathy"},{"id":"GLAUCOMA","name":"Glaucoma"},{"id":"HYPERTENSIVE_RETINOPATHY","name":"Hypertensive Retinopathy"},{"id":"CATARACT","name":"Cataract"},{"id":"OTHER","name":"Others"}];
    this.diseaseCategoryOptions.sort((t1:any,t2:any)=>{
      if(t1.name<t2.name) return -1;
      if(t1.name>t2.name) return 1;
      return 0
    });
    this.diseaseCategoryOptions.unshift({"id":null,"name":"Select Category"});
    this.eyeSegmentOptions = [{id:"DEFAULT",name:"Default"},{id:"ANTERIOR",name:"Anterior"},{id:"POSTERIOR",name:"Posterior"}]
    this.recommendationOptions = ["NARRADF","ANRPFE","UTI"];
    this.findingsOptions = ["AH", "AVN", "BCDR", "BH", "CA", "CP", "CS", "CWS", "D", "DE", "DH", "EB", "ECDR", "FD", "GA", "HD", "HE", "HT", "HV", "LD", "LS", "M", "MA", "MD", "MH", "MO", "MS", "NFLH", "NON", "NS", "ON", "PA", "PC", "PE", "PH", "PRPS", "RPEC", "SD", "SH", "TRD", "VB", "VH", "VT"];
    this.findingsOptions.sort();
    this.getAvailableAccounts();
    this.getAccountConfigurationKeys();
   // this.devices = [];//[{ "name": "None", "value": "null" }, { "name": "Classic", "value": "CLASSIC" }, { "name": "Classic HD", "value": "CLASSIC_HD" }, { "name": "Neo", "value": "NEO" }, { "name": "Neo HD", "value": "NEO_HD" }, { "name": "Ultima", "value": "ULTIMA" }];
  }

  addNewRow(type) {
    this.cfg=new Configurations();
    this.cfg.accountId=this.accountId;
    this.cfg.deviceId=0;
    this.cfg.code="";
    if(type=="DIAGNOSIS"){
    this.cfg.eyeSegment="DEFAULT";
    this.cfg.diseaseCategory=null;
    this.configurationList.push(this.cfg);
    }
    else if(type=="FINDINGS"){
      this.findingsList.push(this.cfg);
    }
    else if(type=="PROGRESSION"){
      this.progressionSectionList.push(this.cfg);
    }
    else if(type=="RECOMMENDATIONS"){
      this.recommendationList.push(this.cfg);
    }
    else if(type=="OPERATOR_REMARKS"){
      this.operatorRemarksList.push(this.cfg);
    }
  }
  removeRow(type,index) {
    if(type=="DIAGNOSIS"){
      this.configurationList.splice(index, 1);
    }
    else if(type=="FINDINGS"){
      this.findingsList.splice(index, 1);
    }
    else if(type=="PROGRESSION"){
      this.progressionSectionList.splice(index, 1);
    }
    else if(type=="RECOMMENDATIONS"){
      this.recommendationList.splice(index, 1);
    }
    else if(type=="OPERATOR_REMARKS"){
      this.operatorRemarksList.splice(index, 1);
    }
  }

  isEnebleAllIcdCodes: Boolean = true;
  isEnableFindingAllIcdCodes: Boolean = true;
  isEnableProgressionAllIcdCodes: Boolean = true;
  isEnableRecommendationAllIcdCodes: Boolean = true;
  isEnableRemarksAllIcdCodes: Boolean = true;

  enableAllIcdCodes() {
    this.isEnebleAllIcdCodes = false;
    this.configurationList.forEach(item => item.status = true);
  }
  
  disableAllIcdCodes() {
    this.isEnebleAllIcdCodes = true;
    this.configurationList.forEach(item => item.status = false);
  }

  enableAllFindingsIcdCodes() {
    this.isEnableFindingAllIcdCodes = false;
    this.findingsList.forEach(item => item.status = true);
  }

  disableAllFindingsIcdCodes() {
    this.isEnableFindingAllIcdCodes = true;
    this.findingsList.forEach(item => item.status = false);
  }

  enableAllProgressionIcdCodes() {
    this.isEnableProgressionAllIcdCodes = false;
    this.progressionSectionList.forEach(item => item.status = true);
  }

  disableAllProgressionIcdCodes() {
    this.isEnableProgressionAllIcdCodes = true;
    this.progressionSectionList.forEach(item => item.status = false);
  }

  enableAllRecommendationIcdCodes() {
    this.isEnableRecommendationAllIcdCodes = false;
    this.recommendationList.forEach(item => item.status = true);
  }

  disableAllRecommendationIcdCodes() {
    this.isEnableRecommendationAllIcdCodes = true;
    this.recommendationList.forEach(item => item.status = false);
  }

  enableAllRemarksIcdCodes() {
    this.isEnableRemarksAllIcdCodes = false;
    this.operatorRemarksList.forEach(item => item.status = true);
  }

  disableAllRemarksIcdCodes() {
    this.isEnableRemarksAllIcdCodes = true;
    this.operatorRemarksList.forEach(item => item.status = false);
  }

  getAvailableAccounts() {
    this.accounts = [];
    this.accountService.getExistingAccounts()
      .subscribe(response => {
        if (response.errorCode == 200 && response.status == this.foruscareService.RESULT_SUCCESS) {
          if (response.data != null) {
            if (response.data.length > 0) {
              response.data.unshift({
                accountName: 'Select Account',
                accountId: 0
              });
            }
            this.accounts = response.data;

          }
        }
        else {
          this.foruscareService.showNotification(response.message, "danger");
        }
      });
  }

  getAllDevices(accountId:any){
    this.devices=[];
    this.deviceService.getAllDevices(this.accountId)
    .subscribe(response=>{
      if(response.errorCode==200 && response.data!=null){
        response.data.forEach(element => {
            this.devices.push({"id":Number(element.deviceId),"name":element.deviceModel});
        });
        // this.devices.unshift({
        //   name: 'Select device',
        //   id: 0
        // });
        setTimeout(() => {
          this.configurationList.forEach(element => {
            element.deviceId= this.devices[0].id;
          });
          this.findingsList.forEach(element => {
            element.deviceId= this.devices[0].id;
          });
          this.progressionSectionList.forEach(element => {
            element.deviceId= this.devices[0].id;
          });
          this.recommendationList.forEach(element => {
            element.deviceId= this.devices[0].id;
          });
          this.operatorRemarksList.forEach(element => {
            element.deviceId= this.devices[0].id;
          });
        }, 100);
        
      }
    });
  }
  
  getAccountConfigurationKeys(){
    this.accountConfigurationKeys = [];
    this.accountService.getAccountConfigurationKeys()
    .subscribe(response=>{
      if(response.errorCode==200){
        if(response.data!=null && response.data.length>0){
          response.data.sort(function(t1,t2){
            if(t1.key<t2.key){ return -1 ;}
            else if(t1.key>t2.key){ return 1 ;}
            else { return 0 ;}
          });
          this.accountConfigurationKeys = response.data;
          /*group dva related keys together */
          let list1 = [];
          let list2 = [];
          this.accountConfigurationKeys.forEach((element)=>{
            if(element.keylabel.toLowerCase().indexOf("essilor")>-1){
              list1.push(element);
            }
            else{
              list2.push(element);
            }
          });
          this.accountConfigurationKeys = list1.concat(list2);
        }
      }
    },error=>{
      this.foruscareService.showNotification("Something went wrong.", "danger");
    });
  }
  getAccountConfigurationValues(){
    this.accountConfigurationValues = [];
    let obj = {
      accountId : this.selectedAccount.accountId
    }
    this.accountService.getAccountConfigurationByAccountId(obj)
    .subscribe(response=>{
      if(response.errorCode==200){
        this.accountConfigurationValues = response.data;
      }
    },error=>{
      this.foruscareService.showNotification("Something went wrong.", "danger");
    });
  }

  getConfigurations(accountId,type,copyFlag) {
    if(accountId>0){
      this.selectedAccount = this.accounts.filter(function(t:any){return t.accountId == accountId})[0];
    }
    if(type=="MRN_CONFIGURATION"){
        this.accountService.getMRNConfigByAccount(accountId)
        .subscribe(response=>{
          if(response.errorCode==200 && response.data!=null){
            this.mrnConfig = response.data;
          }
          else{
            this.mrnConfig = new MRNConfig();
          }
          this.generateMRNPreview();
        },error=>{
          this.foruscareService.showNotification("Something went wrong.", "danger");
          this.generateMRNPreview();
        });
    }
    else if(type=="ACCOUNT_CONFIGURATION"){
      this.accountConfigurationMap = [];
      if(this.accountConfigurationKeys !=null && this.accountConfigurationKeys.length > 0 ){
        this.accountConfigurationKeys.forEach(keys => {
          this.accountConfigurationMap.push({keyId: keys.id,key: keys.key,keylabel:keys.keylabel,keyDescription:keys.keyDescription,value:null});
        });
      }
      this.accountConfigurationValues = [];
      this.accountService.getAccountConfigurationByAccountId({accountId : accountId})
      .subscribe(response=>{
        if(response.errorCode==200){
          this.accountConfigurationValues = response.data;
          if(this.accountConfigurationValues != null || this.accountConfigurationValues.length > 0){
            this.accountConfigurationMap.forEach(map => {
              this.accountConfigurationValues.forEach(values => {
                if(map.key.toLowerCase()==values.key.toLowerCase()){
                  map.value = values.value;
                }
              });
            });
            /*group dva related keys together */
            let list1 = [];
            let list2 = [];
            this.accountConfigurationMap.forEach((element)=>{
              if(element.keylabel.toLowerCase().indexOf("essilor")>-1){
                list1.push(element);
              }
              else{
                list2.push(element);
              }
            });
            this.accountConfigurationMap = list1.concat(list2);
          }
        }
      },error=>{
        this.foruscareService.showNotification("Something went wrong.", "danger");
      });
    }
    else{
      this.fieldCustomizationService.getConfigurationByType(accountId,type)
      .subscribe(response =>{
        if(response.errorCode==200){
          if(type=="DIAGNOSIS"){
            if(copyFlag){
              this.configurationList=response.data;
              this.configurationList.forEach(element => {
                delete element.id;
                element.deviceId=0;
                element.accountId=this.accountId; //adding selected account id
              });
            }
            else{
            this.configurationList=response.data;
            }
          }
          else if(type=="FINDINGS"){
            if(copyFlag){
              this.findingsList=response.data;
              this.findingsList.forEach(element => {
                delete element.id;
                element.deviceId=0;
                element.accountId=this.accountId; //adding selected account id
              });
            }
            else{
            this.findingsList=response.data;
            }
          }
          else if(type=="RECOMMENDATIONS"){
            if(copyFlag){
              this.recommendationList=response.data;
              this.recommendationList.forEach(element => {
                delete element.id;
                element.deviceId=0;
                element.accountId=this.accountId; //adding selected account id
              });
            }
            else{
            this.recommendationList=response.data;
            }
          }
          else if(type=="PROGRESSION"){
            if(copyFlag){
              this.progressionSectionList=response.data;
              this.progressionSectionList.forEach(element => {
                delete element.id;
                element.deviceId=0;
                element.accountId=this.accountId; //adding selected account id
              });
            }
            else{
            this.progressionSectionList=response.data;
            }
          }
          else if(type=="OPERATOR_REMARKS"){
            if(copyFlag){
              this.operatorRemarksList=response.data;
              this.operatorRemarksList.forEach(element => {
                delete element.id;
                element.deviceId=0;
                element.accountId=this.accountId; //adding selected account id
              });
            }
            else{
            this.operatorRemarksList=response.data;
            }
          }
        }
        else{
          this.foruscareService.showNotification("Something went wrong. Please try again", "danger");
        }
        });
    }
    this.getAllDevices(accountId);
    this.getCodeOptions();
    this.screeningCentersByAccount(accountId);
  }

  screeningCentersByAccount(accountId){
    if(accountId>0){
      this.screeningCenterList = [];
      this.accountService.screeningCentersByAccount(accountId)
      .subscribe(response=>{
        if(response.errorCode==200){
          this.screeningCenterList = response.data;
          if(this.screeningCenterList!=null && this.screeningCenterList.length>0){
            this.selectedScreeningCenter = this.screeningCenterList[0];
          }
        }
      },
      error=>{});
    }
  }
  generateMRNPreview(){
    this.previewMRN = "";
    if(this.mrnConfig.isAccountCodeActive){
      this.previewMRN = this.previewMRN + this.selectedAccount.accountCode;
    }
    if(this.mrnConfig.isCenterCodeActive){
      if(this.previewMRN.length>0){
        this.previewMRN = this.previewMRN + "-";
      }
      this.previewMRN = this.previewMRN + this.selectedScreeningCenter.orgCode;
    }
    if(this.mrnConfig.isDateFormatActive){
      if(this.previewMRN.length>0){
        this.previewMRN = this.previewMRN + "-";
      }
      this.previewMRN = this.previewMRN + this.datePipe.transform(new Date(),this.mrnConfig.dateFormat);
    }
    if(this.mrnConfig.isSerialNumberActive){
      if(this.previewMRN.length>0){
        this.previewMRN = this.previewMRN + "-";
      }
      let srNumber="";
      for(let i=0;i<(this.mrnConfig.noOfDigits-1);i++){
        srNumber = srNumber + "0";
      }
      srNumber = srNumber + "1";
      this.previewMRN = this.previewMRN + srNumber;
    }
    console.log(this.previewMRN);
  }
  onSubmit(type) {
    this.validToSubmit = true;
    if(type=="DIAGNOSIS"){
      let anteriorCount = 0;
      let posteriorCount = 0;
      let defaultCount = 0;

      const filteredList = this.configurationList.filter(element => element.status === true);

      filteredList.forEach(element => {
        if (element.description == null || element.description.length == 0 || element.code == null || element.code.length == 0 || element.deviceId ==0) {
          this.validToSubmit = false;
        }
        if(element.eyeSegment == 'ANTERIOR'){
          anteriorCount++;
        }
        if(element.eyeSegment == 'POSTERIOR'){
          posteriorCount++;
        }
        if(element.eyeSegment == 'DEFAULT'){
          defaultCount++;
        }
      });
      
      if (!this.validToSubmit) {
        this.foruscareService.showNotification("Enter all mandatory fields for ICD codes", "danger");
        return false;
      }
      else if((anteriorCount>0 || posteriorCount>0) && defaultCount > 0){
        this.foruscareService.showNotification("Please make sure all enabled ICD codes are set to Default (old flow) or it shall be either Anterior / Posterior", "danger");
        return false;
      }
      else if (this.validToSubmit) {
        this.fieldCustomizationService.addConfigurationByType(this.accountId,this.configurationList,"DIAGNOSIS").subscribe(response => {
          if(response.errorCode==200){
            this.foruscareService.showNotification("ICD codes saved successfully", "success");
          }
          else{
            this.foruscareService.showNotification("Something went wrong. Please try again", "danger");
          }
        });
      }
    }
    else if(type=="FINDINGS"){
      this.findingsList.forEach(element => {
        if (element.description == null || element.description.length == 0 || element.code == null || element.code.length == 0 || element.deviceId ==0) {
          this.validToSubmit = false;
        }
      });
      if (!this.validToSubmit) {
        this.foruscareService.showNotification("Enter all mandatory fields for Findings", "danger");
      }
      else if (this.validToSubmit) {
        this.fieldCustomizationService.addConfigurationByType(this.accountId,this.findingsList,"FINDINGS").subscribe(response => {
          if(response.errorCode==200){
            this.foruscareService.showNotification("Fndings saved successfully", "success");
          }
          else{
            this.foruscareService.showNotification("Something went wrong. Please try again", "danger");
          }
        });
      }
    }
    else if(type=='PROGRESSION'){
      this.progressionSectionList.forEach(element => {
        if (element.description == null || element.description.length == 0 || element.code == null || element.code.length == 0 || element.deviceId ==0) {
          this.validToSubmit = false;
        }
      });
      if (!this.validToSubmit) {
        this.foruscareService.showNotification("Enter all mandatory fields for Progression Section", "danger");
      }
      else if (this.validToSubmit) {
        this.fieldCustomizationService.addConfigurationByType(this.accountId,this.progressionSectionList,"PROGRESSION").subscribe(response => {
          if(response.errorCode==200){
            this.foruscareService.showNotification("Progression saved successfully", "success");
          }
          else{
            this.foruscareService.showNotification("Something went wrong. Please try again", "danger");
          }
        });
      }
    }
    else if(type=="RECOMMENDATIONS"){
      this.recommendationList.forEach(element => {
        if (element.description == null || element.description.length == 0 || element.code == null || element.code.length == 0 || element.deviceId ==0) {
          this.validToSubmit = false;
        }
      });
      if (!this.validToSubmit) {
        this.foruscareService.showNotification("Enter all mandatory fields for recommendation", "danger");
      }
      else if (this.validToSubmit) {
        this.fieldCustomizationService.addConfigurationByType(this.accountId,this.recommendationList,"RECOMMENDATIONS").subscribe(response => {
          if(response.errorCode==200){
            this.foruscareService.showNotification("Recommendation saved successfully", "success");
          }
          else{
            this.foruscareService.showNotification("Something went wrong. Please try again", "danger");
          }
        });
      }
    }
    else if(type=="OPERATOR_REMARKS"){
      this.operatorRemarksList.forEach(element => {
        if (element.description == null || element.description.length == 0 || element.code == null || element.code.length == 0 || element.deviceId ==0) {
          this.validToSubmit = false;
        }
      });
      if (!this.validToSubmit) {
        this.foruscareService.showNotification("Enter all mandatory fields for operator remarks", "danger");
      }
      else if (this.validToSubmit) {
        this.fieldCustomizationService.addConfigurationByType(this.accountId,this.operatorRemarksList,"OPERATOR_REMARKS").subscribe(response => {
          if(response.errorCode==200){
            this.foruscareService.showNotification("Operator remarks saved successfully", "success");
          }
          else{
            this.foruscareService.showNotification("Something went wrong. Please try again", "danger");
          }
        });
      }
    }
    else if(type=="MRN_CONFIGURATION"){
      this.mrnConfig.centerCode = this.selectedScreeningCenter.orgCode;
      this.mrnConfig.accountCode = this.selectedAccount.accountCode;
      this.mrnConfig.accountId = this.selectedAccount.accountId;
      if(this.mrnConfig.id==null || this.mrnConfig.id==0){
        this.accountService.addMRNConfigByAccount(this.mrnConfig)
        .subscribe(response=>{
          if(response.errorCode==200 && response.data!=null){
            this.mrnConfig = response.data;
            this.foruscareService.showNotification("MRN configuration saved successfully", "success");
          }
        },error=>{
          this.foruscareService.showNotification("Something went wrong", "success");
        });
      }
      else{
        this.accountService.updateMRNConfigByAccount(this.mrnConfig)
        .subscribe(response=>{
          this.mrnConfig = response.data;
          this.foruscareService.showNotification("MRN configuration updated successfully", "success");
        },error=>{
          this.foruscareService.showNotification("Something went wrong", "success");
        });
      }
      
    }
    else if(type=="REMOVE_MRN_CONFIGURATION"){
      this.mrnConfig.accountId = this.selectedAccount.accountId;
      this.accountService.removeMRNConfigByAccount(this.mrnConfig.accountId)
      .subscribe(response=>{
        this.foruscareService.showNotification("MRN configuration removed for this account", "success");
        this.mrnConfig = new MRNConfig();
        this.generateMRNPreview();
      },error=>{
        this.foruscareService.showNotification("Something went wrong", "danger");
      });
    }
    else if(type=="ACCOUNT_CONFIGURATION"){
      let reqObj = [];
      this.accountConfigurationMap.forEach(map => {
        reqObj.push({
          accountId : this.selectedAccount.accountId,
          keyId : map.keyId,
          value : map.value
        });
      });
      this.accountService.addUpdateAccountConfig(reqObj)
      .subscribe(response=>{
        if(response.errorCode==200){
        this.foruscareService.showNotification("Account configuration saved", "success");
        }
      },error=>{
        this.foruscareService.showNotification("Something went wrong", "danger");
      });
    }
  }

  deleteConfigurations(type){
    if(type=="DIAGNOSIS"){
      this.configurationList.splice(0);
    }
    else if(type=="FINDINGS"){
      this.findingsList.splice(0);
    }
    else if(type=="RECOMMENDATIONS"){
      this.recommendationList.splice(0);
    }
    else if(type=="PROGRESSION"){
      this.progressionSectionList.splice(0);
    }
    else if(type=="OPERATOR_REMARKS"){
      this.operatorRemarksList.splice(0);
    }
  }
  getDefaultConfigurations(type){
    if(type=="DIAGNOSIS"){
      this.configurationList=[{id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT", description:"Suspected ARMD (age related macular degeneration)",code:"ARMD",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Background retinopathy",code:"BR",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"BRVO (branch retinal vein occlusion)",code:"BRVO",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Cataract",code:"CAT",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"CHRPE",code:"CHRPE",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Choroiditis",code:"CH",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Conjunctivitis",code:"CJ",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Choroidal nevus",code:"CN",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Corneal Opacity",code:"CO",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"CRVO (central retinal vein occlusion)",code:"CRVO",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Diabetic Macular Edema Noted",code:"DME",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Diabetic Macular Edema Present",code:"DME_YES",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"DME Absent",code:"DMEA",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"No Diabetic Macular Edema Present",code:"DME_NO",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"DME Ungradable",code:"DMEU",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"DME(Ungradable)",code:"DME_UNGRADABLE",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"DME(Unspecified)",code:"DME_UNSPECIFIED",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Diabetic Macular Oedema noted",code:"DMO",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Diabetic Macular Oedema Absent",code:"DMOA",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Diabetic Retinopathy Changes Noted",code:"DR",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Disc Pallor",code:"DP",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"DR Absent",code:"DRA",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"DR Ungradable",code:"DRU",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Cystoid Macular Oedema",code:"CYSTOID_MACULAR_OEDEMA",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Pseudophakia",code:"PSEUDOPHAKIA",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Normal",code:"NORMAL",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Early Cataract",code:"EARLY_CATARACT",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Blepharitis",code:"BLEPHARITIS",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Pingecula",code:"PINGECULA",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Squint",code:"SQUINT",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Stye",code:"STYE",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Corneal Scar",code:"CORNEAL_SCAR",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Chalazion",code:"CHALAZION",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Micro cornea",code:"MICRO_CORNEA",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Macro cornea",code:"MACRO_CORNEA",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Corneal abnormality",code:"CORNEAL_ABNORMALITY",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Coloboma of Iris",code:"COLOBOMA_OF_IRIS",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Pigmented Iris",code:"PIGMENTED_IRIS",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Iris Atrophy",code:"IRIS_ATROPHY",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Shallow Anterior chamber ",code:"SHALLOW_ANTERIOR_CHAMBER_",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"YAG PI",code:"YAG_PI",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Ptosis",code:"PTOSIS",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Meibomitis",code:"MEIBOMITIS",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Pseudoexfoliation",code:"PSEUDOEXFOLIATION",deviceId:0,status:true},
      
      
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Mild Diabetic Retinopathy",code:"DR_MILD",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Moderate Diabetic Retinopathy",code:"DR_MODERATE",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"No Diabetic Retinopathy",code:"DR_NO",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"DR(Ungradable)",code:"DR_UNGRADABLE",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"DR(Unspecified)",code:"DR_UNSPECIFIED",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Proliferative Diabetic Retinopathy",code:"DR_PROLIFERATIVE",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Severe Proliferative Diabetic Retinopathy",code:"DR_PROLIFERATIVE",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Mild Proliferative Diabetic Retinopathy",code:"SEVERE_PROLIFERATIVE_DIABETIC_RETINOPATHY",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Moderate Proliferative Diabetic Retinopathy",code:"MODERATE_PROLIFERATIVE_DIABETIC_RETINOPATHY",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Severe Diabetic Retinopathy",code:"DR_SEVERE",deviceId:0,status:true},

      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Epiretinal Membrane",code:"EM",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Glaucomatous Disc Changes Noted",code:"GLC",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Glaucoma suspect",code:"GS",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Hypertensive Retinopathy Changes Noted",code:"HR",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Right Upper Lid",code:"H02.881 MGD",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Right Lower Lid",code:"H02.882 MGD",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Right Upper & Lower Lids",code:"H02.88A MGD",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Left Upper Lid",code:"H02.884 MGD",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Left Lower Lid",code:"H02.885 MGD",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Left Upper & Lower Lid",code:"H02.88B MGD",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Immature Retina",code:"IR",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Lattice",code:"LAT",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Maculopathy",code:"MAC",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Macular Hole",code:"MHO",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Mild DR",code:"MDR",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Mild DME",code:"MDME",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Melanocytoma",code:"MEL",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Myopic Fundus",code:"MF",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Media Hazy",code:"MH",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Myelinated Nerve Fiber Layer",code:"MNFL",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Mild Non-proliferative DR",code:"MNPDR",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Moderate DME",code:"MODME",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Moderate DR",code:"MODR",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Moderate Non-proliferative DR",code:"MONPDR",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Mature Retina",code:"MR",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Microaneurysms",code:"MY",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Normal Fundus",code:"NF",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Nonproliferative retinopathy",code:"NR",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Optic Disc Edema",code:"ODE",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Optic Neuritis",code:"ON",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Other",code:"O",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Other Referable Condition(s)",code:"ORC",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Papilledema",code:"PAP",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Pinguicula",code:"PC",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Suspected Plus Disease",code:"PD",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Proliferative DR",code:"PDR",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Peripheral degeneration",code:"PERD",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Suspected Pre Plus Condition",code:"PPC",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Proliferative retinopathy",code:"PR",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Pterygium",code:"PT",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Required dilated retina examination",code:"RDRE",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Retinal detachment",code:"RD",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Retinal neoplasm",code:"RN",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Retinal Pigment Epithelial changes",code:"RPEC",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Retinal Tear",code:"RT",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Retinitis pigmentosa",code:"RP",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Suspected Retinoblastoma",code:"RTB",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Suspected ROP Stage 1 Zone 1",code:"S1Z1",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Suspected ROP Stage 1 Zone 2",code:"S1Z2",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Suspected ROP Stage 1 Zone 3",code:"S1Z3",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Suspected ROP Stage 2 Zone 1",code:"S2Z1",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Suspected ROP Stage 2 Zone 2",code:"S2Z2",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Suspected ROP Stage 2 Zone 3",code:"S2Z3",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Suspected ROP Stage 3 Zone 1",code:"S3Z1",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Suspected ROP Stage 3 Zone 2",code:"S3Z2",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Suspected ROP Stage 3 Zone 3",code:"S3Z3",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Suspected ROP Stage 4 Zone 1",code:"S4Z1",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Suspected ROP Stage 4 Zone 1",code:"S4Z2",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Suspected ROP Stage 4 Zone 2",code:"S4Z3",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Suspected ROP Stage 4 Zone 3",code:"S5",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Sever DR",code:"SDR",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Severe DME",code:"SDME",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Stargardt Disease",code:"SD",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Severe Non-proliferative DR",code:"SNPDR",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Tesselated Fundus",code:"TF",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Unable to interpret",code:"UTI",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Vitreous hemorrhage",code:"VH",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Zone - 1 in complete vascularisation",code:"PZ1",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Zone - 1 stage 2 secondary to notch",code:"PZ1S2",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"A - ROP",code:"PARP",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Hybrid ROP",code:"HYRP",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Zone - 2 Posterior Incomplete Vascularisation",code:"Z2PI",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Zone - 2 Posterior stage 1",code:"Z2PS1",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Zone - 2 Posterior stage 2",code:"Z2PS2",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Zone - 2 Posterior stage 3",code:"Z2PS3",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Zone - 2 Anterior stage 1 ",code:"Z2AS1",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Zone - 2 Anterior stage 2 ",code:"Z2AS2",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Zone - 2 Posterior stage 3 ",code:"Z2AS3",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Zone - 3 stage I",code:"Z3S1",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Zone - 3 stage 2",code:"Z3S2",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Zone - 3 stage 3",code:"Z3S3",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Zone - 3 stage 4 A .",code:"Z3S4A",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Zone - 2 Posterior stage 3 c̅ Preplus.",code:"ZPSP",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Complete Vascularisation ,",code:"CS",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Zone - 2 Posterior Incomplete Vascularisation",code:"ZPIV",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Zone - 2 Anterior Incomplete Vascularisation",code:"Z2AIV",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"Zone - 3 Incomplete Vascularisation",code:"Z3IV",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"S/P Laser regressing ROP",code:"LROP",deviceId:0,status:true},
      {id:null,accountId:this.accountId,diseaseCategory:null,eyeSegment:"DEFAULT",description:"S/P AntiVEGF regressing ROP",code:"AVROP",deviceId:0,status:true}
    ];
    if(this.devices.length){
      setTimeout(() => {
        this.configurationList.forEach(element => {
          element.deviceId= this.devices[0].id;
        });
      }, 1000);
    }
    
    /*sorting based on description */
    this.configurationList.sort((a,b)=>{
      let first = a.description.toUpperCase();
      let second = b.description.toUpperCase();
      if(first<second) {return -1;}
      if(first>second){return 1;}
      return 0;
    });
    }
    else if(type=="FINDINGS"){
      this.findingsList=[{id:null,accountId:this.accountId,description:"Atrophic hole",code:"AH",deviceId:0,status:true},
      {id:null,accountId:this.accountId,description:"AV nicking",code:"AVN",deviceId:0,status:true},
      {id:null,accountId:this.accountId,description:"Borderline C/D ratio",code:"BCDR",deviceId:0,status:true},
      {id:null,accountId:this.accountId,description:"Blot hemorrhages",code:"BH",deviceId:0,status:true},
      {id:null,accountId:this.accountId,description:"Chorioretinal atrophy",code:"CA",deviceId:0,status:true},
      {id:null,accountId:this.accountId,description:"Choroidal pigmentation",code:"CP",deviceId:0,status:true},
      {id:null,accountId:this.accountId,description:"Chorioretinal scar",code:"CS",deviceId:0,status:true},
      {id:null,accountId:this.accountId,description:"Cotton wool spots",code:"CWS",deviceId:0,status:true},
      {id:null,accountId:this.accountId,description:"Drusen",code:"D",deviceId:0,status:true},
      {id:null,accountId:this.accountId,description:"Disc edema",code:"DE",deviceId:0,status:true},
      {id:null,accountId:this.accountId,description:"Dot hemorrhages",code:"DH",deviceId:0,status:true},
      {id:null,accountId:this.accountId,description:"Embolus",code:"EB",deviceId:0,status:true},
      {id:null,accountId:this.accountId,description:"Enlarged C/D ratio",code:"ECDR",deviceId:0,status:true},
      {id:null,accountId:this.accountId,description:"Familial drusen",code:"FD",deviceId:0,status:true},
      {id:null,accountId:this.accountId,description:"Geographic atrophy",code:"GA",deviceId:0,status:true},
      {id:null,accountId:this.accountId,description:"Hard Drusen",code:"HD",deviceId:0,status:true},
      {id:null,accountId:this.accountId,description:"Hard exudates",code:"HE",deviceId:0,status:true},
      {id:null,accountId:this.accountId,description:"Horseshoe tear",code:"HT",deviceId:0,status:true},
      {id:null,accountId:this.accountId,description:"Hazy view",code:"HV",deviceId:0,status:true},
      {id:null,accountId:this.accountId,description:"Large Drusen",code:"LD",deviceId:0,status:true},
      {id:null,accountId:this.accountId,description:"Laser scars",code:"LS",deviceId:0,status:true},
      {id:null,accountId:this.accountId,description:"Maculopathy",code:"M",deviceId:0,status:true},
      {id:null,accountId:this.accountId,description:"Macroaneurysm",code:"MA",deviceId:0,status:true},
      {id:null,accountId:this.accountId,description:"Medium Drusen",code:"MD",deviceId:0,status:true},
      {id:null,accountId:this.accountId,description:"Macular hole",code:"MH",deviceId:0,status:true},
      {id:null,accountId:this.accountId,description:"Media opacity",code:"MO",deviceId:0,status:true},
      {id:null,accountId:this.accountId,description:"Macular scar",code:"MS",deviceId:0,status:true},
      {id:null,accountId:this.accountId,description:"NFL hemorrhage",code:"NFLH",deviceId:0,status:true},
      {id:null,accountId:this.accountId,description:"Neovascularization of ON",code:"NON",deviceId:0,status:true},
      {id:null,accountId:this.accountId,description:"Neovascularization",code:"NS",deviceId:0,status:true},
      {id:null,accountId:this.accountId,description:"Optic nerve pallor",code:"ON",deviceId:0,status:true},
      {id:null,accountId:this.accountId,description:"Peripapillary atrophy",code:"PA",deviceId:0,status:true},
      {id:null,accountId:this.accountId,description:"Pigment clumping",code:"PC",deviceId:0,status:true},
      {id:null,accountId:this.accountId,description:"Papilledema",code:"PE",deviceId:0,status:true},
      {id:null,accountId:this.accountId,description:"Preretinal heme",code:"PH",deviceId:0,status:true},
      {id:null,accountId:this.accountId,description:"PRP scars",code:"PRPS",deviceId:0,status:true},
      {id:null,accountId:this.accountId,description:"RPE changes",code:"RPEC",deviceId:0,status:true},
      {id:null,accountId:this.accountId,description:"Soft Drusen",code:"SD",deviceId:0,status:true},
      {id:null,accountId:this.accountId,description:"Splinter hemorrhage",code:"SH",deviceId:0,status:true},
      {id:null,accountId:this.accountId,description:"Traction retinal detachment",code:"TRD",deviceId:0,status:true},
      {id:null,accountId:this.accountId,description:"Venous beading",code:"VB",deviceId:0,status:true},
      {id:null,accountId:this.accountId,description:"Vitreous hemorrhage",code:"VH",deviceId:0,status:true},
      {id:null,accountId:this.accountId,description:"Vascular tortuousity",code:"VT",deviceId:0,status:true}];
     
    }
    else if(type=="RECOMMENDATIONS"){
      this.recommendationList=[{id:null,accountId:this.accountId,description:"Abnormalities noted; recommend prompt further evaluation by ophthalmologist",code:"ANRPFE",deviceId:0,status:true},
      {id:null,accountId:this.accountId,description:"No abnormalities noted on this fundus image; recommend routine annual dilated fundus exam with ophthalmologist",code:"NARRADF",deviceId:0,status:true},
      {id:null,accountId:this.accountId,description:"Unable to interpret",code:"UTI",deviceId:0,status:true}];
    }
    else if(type=="PROGRESSION"){
      this.progressionSectionList=[{id:null,accountId:this.accountId,description:"Yes",code:"YES",deviceId:0,status:true},
      {id:null,accountId:this.accountId,description:"No",code:"NO",deviceId:0,status:true},
      {id:null,accountId:this.accountId,description:"Not Applicable",code:"NA",deviceId:0,status:true}];
    }
    else if(type=="OPERATOR_REMARKS"){
      this.operatorRemarksList = [];
      this.fieldCustomizationService.getDropdownConfigByType("OPERATOR_REMARKS").subscribe(response => {
        if(response.errorCode==200){
          if(response.data && response.data.length>0){
            response.data.forEach(element => {
              this.operatorRemarksList.push({id:null,accountId:this.accountId,description:element.description,code:element.code,deviceId:0,status:true});
            });
            this.sortList(this.operatorRemarksList,"description");
        }
        }
        else{
          this.foruscareService.showNotification("Something went wrong. Please try again", "danger");
        }
      });
    }
  }
  getCodeOptions(){
    this.operatorRemarkOptions = [];
    this.fieldCustomizationService.getDropdownConfigByType("ALL").subscribe(response => {
      if(response.errorCode==200){
        if(response.data && response.data.length>0){
          response.data.forEach(element => {
            switch(element.category){
              case "OPERATOR_REMARKS":
                this.operatorRemarkOptions.push(element.code);
                break;
            }
          });
          this.operatorRemarkOptions.sort();
      }
      }
      else{
        this.foruscareService.showNotification("Something went wrong. Please try again", "danger");
      }
    });
  }
  sortList(list:any[],sortBy){
    return list.sort(function(t1,t2){
      if(t1[sortBy]>t2[sortBy]){
        return 1;
      }
      else if(t1[sortBy]<t2[sortBy]){
        return -1;
      }
      else{
        return 0;
      }
    });
  }
}
